/**
 * @author gabyong.kim
 * @email gabyong.kim@gloovir.com
 * @create date 2023-11-28 16:53:49
 * @modify date 2023-11-28 16:53:49
 * @desc [description]
 */

import { Fragment } from "react";
import { Route, Routes } from "react-router-dom";
import ContentsProps from '../../../interfaceTypes/ContentsProps';
import SmtpMgmtContainer from "./SmtpMgmtContainer";


export default function SmtpMgmtPage(props:ContentsProps) {
  return (
    <Fragment>
      <Routes>
        <Route path={`/`} element={<SmtpMgmtContainer setLoading={props.setLoading} showSlideModalCb={props.showSlideModalCb} showPopupModalCb={props.showPopupModalCb}/>} />
      </Routes>
    </Fragment>
  )

}